<div class="compare-vechicle-sec mb-3">
  <div class="">
      <div class="content-heading">
          <h2>Compare Vehicle</h2>
      </div>
      <div class="table-responsive">
          <table class="table table-sm table-borderless compare-table">
              <thead class="compare-sel">
                  <tr>
                      <td></td>
                      <td></td>
                      <td>
                          <select class="form-select" name="select-v" (change)="getItemTwo($event)"
                              [(ngModel)]="selectedAccountTwo" >
                              <option value="" selected>Select PPL</option>
                              <ng-container *ngFor="let group of DataTwoArray">
                                  <optgroup label="{{ group.name }}" *ngIf="group.values?.length > 0">
                                      <option (focus)="generateTwoArray()" value="{{ grp.pl }}" *ngFor="let grp of group.values">
                                          {{ grp.pl }}
                                      </option>
                                  </optgroup>
                              </ng-container>
                          </select>
                      </td>
                      <td>
                          <select class="form-select" name="select-v" (change)="getItemThree($event)"
                              [(ngModel)]="selectedAccountThree"
                              [disabled]="!productDetailsDataTwo && !productDetailsDataThree">
                              <option value="" selected>Select PPL</option>
                              <ng-container *ngFor="let group of DataThreeArray">
                                  <optgroup label="{{ group.name }}" *ngIf="group.values?.length > 0">
                                      <option (focus)="generateThreeArray()" value="{{ grp.pl }}" *ngFor="let grp of group.values">
                                          {{ grp.pl }}
                                      </option>
                                  </optgroup>
                              </ng-container>
                          </select>
                      </td>
                  </tr>
                  <tr>
                      <td></td>
                      <td></td>
                      <td>
                          <select class="form-select" name="select-v" (change)="getTruckBusTwo()"
                              [(ngModel)]="selectedTruckBusTwo">
                              <option value="" selected>Select Model</option>
                              <option *ngFor="let model of modelDataTwo" value="{{ model.id }}">
                                  {{ model.product_description | titlecase }}
                              </option>
                          </select>
                      </td>
                      <td>
                          <select class="form-select" name="select-v" (change)="getTruckBusThree()"
                              [(ngModel)]="selectedTruckBusThree"
                              [disabled]="!productDetailsDataTwo && !productDetailsDataThree">
                              <option value="" selected>Select Model</option>
                              <option *ngFor="let model of modelDataThree" value="{{ model.id }}">
                                  {{ model.product_description | titlecase }}
                              </option>
                          </select>
                      </td>
                  </tr>
              </thead>
              <thead>
                  <tr>
                      <th></th>
                      <th>
                          <div class="comp-item-img" *ngIf="productDetailsDataOne" #cardElement>
                              <img *ngIf="productDetailsDataOne?.images[0]?.image_url"
                                  [src]="updateImageSize(productDetailsDataOne?.images[0]?.image_url, cardElement)" class="img-fluid"
                                  alt="{{ productDetailsDataOne?.model }}" loading="lazy">
                              <img *ngIf="!productDetailsDataOne?.images[0]?.image_url"
                                  [src]='environment1 + "assets/images/default_vehicle_img.webp"' class="img-fluid"
                                  alt="{{ productDetailsDataOne?.model }}" loading="lazy">
                          </div>
                          <div class="comp-item-content">
                              <p>{{ productDetailsDataOne?.model }}</p>
                              <h5><span *ngIf="productDetailsDataOne?.price_range">{{
                                      productDetailsDataOne?.price_range ? (productDetailsDataOne?.price_range
                                      |currency:'INR':'symbol':'4.0-0') : "-" }}</span>
                                  <span *ngIf="productDetailsDataOne && !productDetailsDataOne?.price_range">Please
                                      contact to Dealer.</span>
                              </h5>
                              <div class="book-now-cta d-grid"  *ngIf="productDetailsDataOne">
                                  <button type="button" class="btn btn-primary text-nowrap btn-grad-primary"
                                      (click)="bookNow(productDetailsDataOne)" data-toggle="tooltip" data-placement="top" title="Click here for Booking"
                                      >Book Now At {{ ((productDetailsDataOne?.down_payment | currency:'INR':'symbol':'4.0-0')) }}
                                  </button>
                              </div>
                          </div>
                      </th>

                      <th>
                          <div class="comp-item-img" *ngIf="productDetailsDataTwo" #cardElement>
                              <img [src]="updateImageSize(productDetailsDataTwo?.images[0]?.image_url, cardElement)" width="178px"
                                  height="115px" class="img-fluid" alt="{{ productDetailsDataTwo?.model }}" loading="lazy">
                          </div>
                          <div class="comp-item-content">
                              <p>{{ productDetailsDataTwo?.model }}</p>
                              <h5><span *ngIf="productDetailsDataTwo?.price_range">{{
                                      productDetailsDataTwo?.price_range ? (productDetailsDataTwo?.price_range
                                      |currency:'INR':'symbol':'4.0-0') : "-" }}</span>
                                  <span *ngIf="productDetailsDataTwo && !productDetailsDataTwo?.price_range">Please
                                      contact to Dealer.</span>
                              </h5>
                              <div class="book-now-cta d-grid">
                                  <!-- <button type="button" class="btn btn-primary text-nowrap  btn-grad-primary" (click)="bookNow(productDetailsDataTwo)" [disabled]="!productDetailsDataTwo">Book Now</button> -->
                                  <button type="button" [disabled]="!productDetailsDataTwo"
                                      class="btn btn-primary text-nowrap btn-grad-primary"
                                      (click)="bookNow(productDetailsDataTwo)"
                                      data-toggle="tooltip" data-placement="top" title="Click here for Booking">
                                      <span *ngIf="!productDetailsDataTwo">Book Now</span>
                                      <span *ngIf="productDetailsDataTwo">Book Now At {{
                                          ((productDetailsDataTwo?.down_payment | currency:'INR':'symbol':'4.0-0'))
                                          }}</span> </button>

                              </div>
                          </div>
                      </th>
                      <th>
                          <div class="comp-item-img" *ngIf="productDetailsDataThree" #cardElement>
                              <img [src]="updateImageSize(productDetailsDataThree?.images[0]?.image_url, cardElement)" width="178px"
                                  height="115px" class="img-fluid" alt="{{ productDetailsDataThree?.model }}" loading="lazy">
                          </div>
                          <div class="comp-item-content">
                              <p>{{ productDetailsDataThree?.model }}</p>
                              <h5><span *ngIf="productDetailsDataThree?.price_range">{{
                                      productDetailsDataThree?.price_range ? (productDetailsDataThree?.price_range
                                      |currency:'INR':'symbol':'4.0-0') : "-" }}</span>
                                  <span
                                      *ngIf="productDetailsDataThree && !productDetailsDataThree?.price_range">Please
                                      contact to Dealer.</span>
                              </h5>
                              <div class="book-now-cta d-grid">
                                  <button type="button" [disabled]="!productDetailsDataThree"
                                      class="btn btn-primary text-nowrap btn-grad-primary"
                                      (click)="bookNow(productDetailsDataThree)"
                                      data-toggle="tooltip" data-placement="top" title="Click here for Booking">
                                      <span *ngIf="!productDetailsDataThree">Book Now</span>
                                      <span *ngIf="productDetailsDataThree">Book Now At {{
                                          ((productDetailsDataThree?.down_payment | currency:'INR':'symbol':'4.0-0'))
                                          }}</span> </button>
                              </div>
                          </div>
                      </th>
                  </tr>
              </thead>


              <tbody>
                  <tr>
                      <td>
                          <div class="comp-item-heading">
                              <img [src]='environment1 + "assets/images/c-Engine.svg"' class="img-fluid" loading="lazy" alt="c-Engine"/>
                              <span *ngIf="(!performanceOne && !performanceTwo && !performanceThree)">Engine
                                  Type</span>
                              <span
                                  *ngIf="(performanceOne || performanceTwo || performanceThree) && (performanceOne.fuel_type == 'EV' || performanceTwo?.fuel_type == 'EV' || performanceThree?.fuel_type == 'EV' || performanceOne?.fuel_type == 'Electric' || performanceTwo?.fuel_type == 'Electric' || performanceThree?.fuel_type == 'Electric')">Engine
                                  Type / Motor Type</span>
                              <span
                                  *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && !performanceTwo && !performanceThree)">Engine
                                  Type</span>
                              <span
                                  *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo && performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && !performanceThree">Engine
                                  Type</span>
                              <span
                                  *ngIf="((performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && performanceThree && (performanceThree?.fuel_type != 'EV' && performanceThree?.fuel_type != 'Electric')">Engine
                                  Type</span>
                          </div>
                      </td>
                      <td>
                          {{ performanceOne && performanceOne.engine_type ? performanceOne.engine_type : "-" }} </td>
                      <td>
                          {{ performanceTwo && performanceTwo.engine_type ? performanceTwo.engine_type : "-" }} </td>
                      <td>
                          {{ performanceThree && performanceThree.engine_type ? performanceThree.engine_type : "-" }}
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <div class="comp-item-heading">
                              <img [src]='environment1 + "assets/images/c-Speedometer.svg"' class="img-fluid" loading="lazy" alt="c-Speedometer"/>
                              <span *ngIf="(!performanceOne && !performanceTwo && !performanceThree)">
                                  Max Power</span>
                              <span
                                  *ngIf="(performanceOne || performanceTwo || performanceThree) && (performanceOne.fuel_type == 'EV' || performanceTwo?.fuel_type == 'EV' || performanceThree?.fuel_type == 'EV' || performanceOne?.fuel_type == 'Electric' || performanceTwo?.fuel_type == 'Electric' || performanceThree?.fuel_type == 'Electric')">
                                  Max Power / Max Motor Power</span>
                              <span
                                  *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && !performanceTwo && !performanceThree)">
                                  Max Power</span>
                              <span
                                  *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo && performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && !performanceThree">
                                  Max Power</span>

                              <span
                                  *ngIf="((performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && performanceThree && (performanceThree?.fuel_type != 'EV' && performanceThree?.fuel_type != 'Electric')">
                                  Max Power</span>
                          </div>
                      </td>
                      <td>
                          {{ performanceOne && performanceOne.max_power ? performanceOne.max_power : "-" }}
                      </td>
                      <td>
                          {{ performanceTwo && performanceTwo.max_power ? performanceTwo.max_power : "-" }}
                      </td>
                      <td>
                          {{ performanceThree && performanceThree.max_power ? performanceThree.max_power : "-" }}
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <div class="comp-item-heading">
                              <img [src]='environment1 + "assets/images/c-Torque.svg"' class="img-fluid" loading="lazy" alt="c-Torque"/><span>Max Torque</span>
                          </div>
                      </td>
                      <td>
                          {{ performanceOne && performanceOne.max_torque ? performanceOne.max_torque : "-" }} </td>
                      <td>
                          {{ performanceTwo && performanceTwo.max_torque ? performanceTwo.max_torque : "-" }}
                      </td>
                      <td>
                          {{
                          performanceThree && performanceThree.max_torque ? performanceThree.max_torque : "-"
                          }} </td>
                  </tr>
                  <tr>
                      <td>
                          <div class="comp-item-heading">
                              <img [src]='environment1 + "assets/images/c- Wheels.svg"' class="img-fluid" alt="c- Wheels" loading="lazy" alt="c-Wheels"/> <span>No of Wheels</span>
                          </div>
                      </td>
                      <td>
                          {{ performanceOne && performanceOne.no_wheels ? performanceOne.no_wheels : "-" }}
                      </td>
                      <td>
                          {{ performanceTwo && performanceTwo.no_wheels ? performanceTwo.no_wheels : "-" }}
                      </td>
                      <td>
                          {{
                          performanceThree && performanceThree.no_wheels ? performanceThree.no_wheels : "-"
                          }}
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <div class="comp-item-heading">
                              <img [src]='environment1 + "assets/images/c-fuel.svg"' alt="c-fuel" class="img-fluid" loading="lazy"/>
                              <span *ngIf="(!performanceOne && !performanceTwo && !performanceThree)"> Fuel Tank
                                  Capacity (Litres)</span>
                              <span
                                  *ngIf="(performanceOne || performanceTwo || performanceThree) && (performanceOne.fuel_type == 'EV' || performanceTwo?.fuel_type == 'EV' || performanceThree?.fuel_type == 'EV' || performanceOne?.fuel_type == 'Electric' || performanceTwo?.fuel_type == 'Electric' || performanceThree?.fuel_type == 'Electric')">
                                  Fuel Tank Capacity (Litres) / Battery Capacity (kWh)</span>
                              <span
                                  *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && !performanceTwo && !performanceThree)">
                                  Fuel Tank Capacity (Litres)</span>
                              <span *ngIf="((performanceOne && performanceOne?.fuel_type !='EV' &&
                                  performanceOne?.fuel_type !='Electric' ) && (performanceTwo &&
                                  performanceTwo?.fuel_type !='EV' && performanceTwo?.fuel_type !='Electric' )) &&
                                  !performanceThree">
                                  Fuel Tank Capacity (Litres)</span>

                                  <span
                                      *ngIf="((performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && performanceThree && (performanceThree?.fuel_type != 'EV' && performanceThree?.fuel_type != 'Electric')">
                                      Fuel Tank Capacity (Litres)</span>
                          </div>
                      </td>
                      <td>
                          {{
                          performanceOne && performanceOne.fuel_tank_capacity
                          ? performanceOne.fuel_tank_capacity
                          : "-"
                          }}
                      </td>
                      <td>
                          {{
                          performanceTwo && performanceTwo.fuel_tank_capacity
                          ? performanceTwo.fuel_tank_capacity
                          : "-"
                          }}
                      </td>
                      <td>
                          {{
                          performanceThree && performanceThree.fuel_tank_capacity
                          ? performanceThree.fuel_tank_capacity
                          : "-"
                          }}
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <div class="comp-item-heading">
                              <img [src]='environment1 + "assets/images/c-GCW.svg"' class="img-fluid" loading="lazy" alt="c-GCW"/><span>GVW/GCW</span>
                          </div>
                      </td>
                      <td>
                          {{ performanceOne && performanceOne.gvw ? performanceOne.gvw : "-" }}
                      </td>
                      <td>
                          {{ performanceTwo && performanceTwo.gvw ? performanceTwo.gvw : "-" }}
                      </td>
                      <td>
                          {{ performanceThree && performanceThree.gvw ? performanceThree.gvw : "-" }}
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
      <div class="compare-table-content d-block d-md-flex">
          <div class="ltr order-2 order-md-1">
              <p>Prices mentioned above are ex-showroom price. All models may not include accessories. For any other
                  configurations, contact cac&#64;tatamotors.com</p>
          </div>
          <div class="rtl order-1 order-md-2">
              <a (click)="redirect()" [ngClass]="!showcursor ? 'cross-cursor' : 'cursor'">See Full Comparison
                <img [src]="environment1 + 'images/new-images/rightArrowblue.svg'" alt="right Arrowblue" loading="lazy">
              </a>
          </div>
      </div>
  </div>
</div>
